import apiClient from "./ApiClient";
import handleApiError from "./handleApiError";

export default {
    sendExportData(form){
        return apiClient.post(`/api/v1/tickets/export`, form).then(resp => resp).catch(handleApiError);
    }
}
